// @flow
import './style/titleist.css';
import withClientPage from '../../hoc/withClientPage';
import withTemplate from '../../hoc/templates/withTemplate';
import withBasic from '../../hoc/templates/withBasic';

const PassedProps = {
  clientBodyClassNames: 'container-fluid titleist-main',
  header: 'none',
  headingText: 'ALREADY HAVE A GIFT CARD?',
  cardInputLabel: '',
  pinInputLabel: '',
  clientContentClassNames: 'col-sm-12 col-md-6 col-lg-6',
  cardInputPlaceholder: 'Gift Card Number',
  pinInputPlaceholder: 'PIN',
  buttonClassNames: 'btn text-white check-balance-button',
  resultsClassNames: '',
  resultsHeadingText: 'Gift Card Balance',
  showEnhancedResults: false,
  showCardEOV: false,
  justifyContent: 'center',
};

const clientPageProps = {
  title: 'titleist.title',
  favicon: '/titleist.ico',
  callTranslations: PassedProps.showEnhancedResults,
};

const FJUGC = () => null;

export default withClientPage(withTemplate(withBasic(FJUGC), PassedProps), clientPageProps);
